import { AbstractControl, ValidatorFn } from '@angular/forms';
import { REGEX } from '../core/validation';

export function timeValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value ? control.value : '';
    if (!value) {
      return null;
    }

    // Regular expression to validate time in HH:mm or hh:mm a format
    const isValidTime =
      REGEX.TIME_TWELVE_HOUR_FORMAT.test(value) ||
      REGEX.TIME_TWENTY_HOUR_FORMAT.test(value);
    return isValidTime ? null : { invalidTime: { value: control.value } };
  };
}
